
<script>
  import * as R from 'ramda';
  import UseResource from 'components/svg/UseResource.svelte';

  export let type;
  export let data;

  const accessors = {
    facility: [
      [
        R.prop('icon')
      ],
      R.prop('title')
    ],
    newsAndEvent: [
      [
        R.path(['images', 0])
      ],
      R.prop('title')
    ],
    offer: [
      [
        R.path(['images', 0]),
        R.path(['store', 'logoURL']),
        R.always('svg:ic_offer')
      ],
      R.prop('title')
    ],
    store: [
      [
        R.prop('logoURL'),
        R.always('svg:ic_store')
      ],
      R.prop('name')
    ]
  };

  const notNil = R.compose(R.not, R.isNil);

  const takeFirstGood = (data, fallbacks) => R.pipe(
    R.map(R.applyTo(data)),
    R.find(notNil)
  )(fallbacks);

  let props = {};
  let cover = false;

  $: if (data) {
    if (accessors[type]) {
      const [src, alt] = accessors[type];
      const srcVal = takeFirstGood(data, src);
      const isResource = /^svg:/.test(srcVal);
      cover = type == 'newsAndEvent';

      props = {
        src: srcVal.replace(/^svg:/, ''),
        alt: alt(data),
        isResource
      };
    }
    else {
      console.error(`Missing accessor for '${type}'`);
    }
  }

  $: style = cover ? 'object-fit: cover' : '';

</script>

<div class="thumb thumb--{type}">
  {#if props.isResource}
    <UseResource name="{props.src}" />
  {:else if props.src}
    <img src="{props.src}" alt="{props.alt}" {style} />
  {/if}
</div>

<style>
  .thumb {
    --object-fit: contain;
    --background: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 72px;

    background: var(--background);
    overflow: hidden;
  }

  .thumb--facility {
    --background: transparent;
  }

  .thumb img {
    width: 100%;
    height: 100%;
    object-fit: var(--object-fit);
  }

  .thumb :global(.resource) {
    opacity: .5;
  }
</style>
